import React from "react";
import { Flex } from "@procore/core-react";
import { SupportCenterCard } from "./support-center-card";
import { CompanyCard } from "./company-card";
import { NotificationsCard } from "./notifications-card";
import { ProjectTearsheetProvider } from "../tearsheets/project/project-tearsheet";
import { PersonTearsheetProvider } from "../tearsheets/people/people-tearsheet";

const HOME_CONTAINER_BACKGROUND_COLOR = "hsl(200, 8%, 96%)";
const HOME_CONTAINER_VERTICAL_SPACING = "2rem";

export const HomeContainer = () => {
   return (
      <ProjectTearsheetProvider>
         <PersonTearsheetProvider>
            <Flex
               padding="lg"
               gap="sm"
               style={{
                  backgroundColor: HOME_CONTAINER_BACKGROUND_COLOR,
                  height: `calc(100% - ${HOME_CONTAINER_VERTICAL_SPACING})`,
               }}
            >
               <Flex direction="column" gap="sm">
                  <CompanyCard />
                  <SupportCenterCard />
               </Flex>
               <NotificationsCard />
            </Flex>
         </PersonTearsheetProvider>
      </ProjectTearsheetProvider>
   );
};
